import { timestampToDate } from "../util/misc";
import { store } from "../store";

const PAYROLL_RECORD_FIELDS = {
  payrollDate: null,
  payrollNumber: null,
  fileName: null,
  employeeInitials: null,
  employeeUserID: null,
  employeeName: null,
  employeePoid: null,
  po: null,
  invoiceNumber: null,
  totalWithTax: null,
  preTaxTotal: null,
  payments: null,
  cog: null,
  gpmPercent: null,
  commissionPercent: null,
  basePay: null,
  manualPayOverride: null,
  notes: null,
  section: null, // "commission" or "advanced"
  expectedDate: null,
  importedAt: null,
  importedBy: null,
};

export default class PayrollRecord {
  constructor(id, data = {}) {
    this.id = id;

    // Apply defaults
    const d = { ...PAYROLL_RECORD_FIELDS, ...data };

    // Convert timestamps to Dates
    d.payrollDate = timestampToDate(d.payrollDate);
    d.expectedDate = timestampToDate(d.expectedDate);
    d.importedAt = timestampToDate(d.importedAt);

    this.data = Object.freeze(d);

    // Create top-level getters for each field
    Object.keys(d).forEach((key) => {
      if (!(key in this)) {
        Object.defineProperty(this, key, {
          get: () => this.data[key],
          enumerable: true,
        });
      }
    });
  }

  get stateID() {
    return this.id;
  }

  get user() {
    if (!this.employeeUserID) return null;
    return store.state.main.users[this.employeeUserID] || null;
  }

  get actualCommPaid() {
    const base = this.basePay || 0;
    const override = this.manualPayOverride || 0;
    return base + override;
  }

  // Permissions

  static canBeViewedBy(user) {
    return user.isAdmin || (user.isEmployee && user.hasRole("payroll"));
  }

  // Database

  static getPath(id) {
    let path = "payrollRecords";
    if (id) path += `/${id}`;
    return path;
  }

  static getStateID(path) {
    const match = path.match(/^payrollRecords\/([^/]+)$/);
    return match ? match[1] : null;
  }

  static toFirestore(record) {
    return record.data;
  }

  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return new PayrollRecord(snapshot.id, data);
  }
}
